import { render, staticRenderFns } from "./RightshipInspectionSettings.vue?vue&type=template&id=b8c96e1a&scoped=true&"
import script from "./RightshipInspectionSettings.vue?vue&type=script&lang=js&"
export * from "./RightshipInspectionSettings.vue?vue&type=script&lang=js&"
import style0 from "./RightshipInspectionSettings.vue?vue&type=style&index=0&id=b8c96e1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c96e1a",
  null
  
)

export default component.exports